import script from "./member-savings-report-table.vue?vue&type=script&setup=true&lang=js"
export * from "./member-savings-report-table.vue?vue&type=script&setup=true&lang=js"

import "./member-savings-report-table.vue?vue&type=style&index=0&id=0b7d7048&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b7d7048"]])

export default __exports__